import axios from 'axios';
import { Notification } from 'element-ui';
import router from '@/router';
import store from '@/store';

const codeMessage = {
  200: '服务器成功返回请求的数据。',
  201: '新建或修改数据成功。',
  202: '一个请求已经进入后台排队（异步任务）。',
  204: '删除数据成功。',
  400: '发出的请求有错误，服务器没有进行新建或修改数据的操作。',
  401: '用户没有权限（令牌、用户名、密码错误）。',
  403: '用户得到授权，但是访问是被禁止的。',
  404: '发出的请求针对的是不存在的记录，服务器没有进行操作。',
  406: '请求的格式不可得。',
  410: '请求的资源被永久删除，且不会再得到的。',
  422: '当创建一个对象时，发生一个验证错误。',
  500: '服务器发生错误，请检查服务器。',
  502: '网关错误。',
  503: '服务不可用，服务器暂时过载或维护。',
  504: '网关超时。',
};
const errCode = [201, 400, 401, 402, 404, 405, 500, 600, 700];

// 创建 axios 实例
const instance = axios.create({
  timeout: 6000,
  headers: { 'X-Requested-Page': 'json' },
  baseURL: process.env.VUE_APP_BASE_API,
});

// 提示
function notification(title, errorText) {
  Notification.error({
    title,
    message: errorText,
  });
}

// 清除，重新登陆
async function resetTokenAndToLogin() {
  await store.dispatch('user/logout').catch(() => {});
  router.replace('/user/login');
}

// 响应处理程序
const responseHandler = async (res) => {
  const { data } = res;

  if (errCode.includes(data.code)) {
    if (data.code === 700) {
      resetTokenAndToLogin();
    }
    return Promise.reject(data.msg);
  }
  return Promise.resolve(data);
};

// 异常处理程序
const errorHandler = async (error) => {
  const { response } = error;

  if (response && response.status) {
    const errorText = codeMessage[response.status] || response.statusText;
    const { status } = response;

    switch (status) {
      case 401:
        resetTokenAndToLogin();
        break;
      case 403:
        notification('无权限访问', errorText);
        break;
      default:
        notification(`请求错误 ${status}`, errorText);
        break;
    }
  }
  return Promise.reject(response);
};

// 请求拦截
instance.interceptors.request.use(
  (config) => config,
  (err) => Promise.reject(err),
);

// 响应拦截
instance.interceptors.response.use(
  (res) => {
    if (res.status === 200) {
      return responseHandler(res);
    }
    return Promise.reject(res.data);
  },
  (err) => errorHandler(err),
);

export default instance;
